import { useEffect, useContext } from 'react';
import { history, IRouteComponentProps, useParams } from 'umi';
import { useDispatch } from 'dva';
import Context from '@/utils/context';
import { useIntl } from 'react-intl';
import { Row, Col } from 'antd';
import { Form, Modal, message } from 'iglooform';
import { BackButton } from '@/components/back-button/back-button';
import { HeaderTitle } from '@/components/header-title/header-title';
import { aesEncrypt } from '@/utils/common';
import throttle from 'lodash/throttle';
import { verifyPaymentPassword, bindBankAccount } from '../service';
import './index.less';
import { payNumberReg } from '@/utils/regexp';

const VerifyPaymentPasswordPage = ({ location }: IRouteComponentProps) => {
  const { query, pathname } = location;
  const form = Form.useForm();
  const { isPc } = useContext(Context);
  const { formatMessage } = useIntl();
  const { type }: any = useParams();
  const dispatch = useDispatch();
  const currentLang = localStorage.getItem(SELECTED_LANG) || 'vi-VN';
  const bindAccount = (payment_password: string, type: string) => {
    const back_url =
      type === 'change-account'
        ? `${window.location.protocol}//${window.location.host}/me/receiving-account`
        : `${window.location.protocol}//${window.location.host}/earnings/cash-out?balance=${query['balance']}&minWithdrawAmount=${query['minWithdrawAmount']}&account=${query['account']}`;

    bindBankAccount({
      payment_password: payment_password,
      failed_redirect_url: back_url,
      pending_redirect_url: back_url,
      succeed_redirect_url: back_url,
    }).then((res) => {
      if (res && res.link) {
        dispatch({
          type: 'global/toRedirectNewPage',
          payload: {
            url: `${res.link}&lang=${currentLang}`,
          },
        });
        Modal.confirm({
          width: 500,
          title: formatMessage({ id: 'Confirm' }),
          content: formatMessage({
            id: 'Are you sure to bind bank account successfully?',
          }),
          okText: formatMessage({ id: 'Yes' }),
          cancelText: formatMessage({ id: 'No' }),
          closable: false,
          maskClosable: false,
          onOk: () => {
            history.goBack();
          },
        });
      }
    });
  };
  const handleVerifyPaymentPassword = throttle(
    async (values: any) => {
      try {
        verifyPaymentPassword({
          password: values.payment_password.trim(),
        }).then((res) => {
          if (res.ok === true) {
            if (type === 'change-payment-password') {
              // 修改Payment Password，验证后跳转
              history.push(
                `/me/change-password/reset/${aesEncrypt(
                  values.payment_password.trim(),
                )}`,
              );
            } else if (type === 'change-password') {
              // 修改密码，验证后跳转
              history.push({
                pathname: '/me/change-password/reset',
              });
            } else if (
              ['change-account', 'cashout-change-account'].includes(type)
            ) {
              bindAccount(values.payment_password.trim(), type); // 绑定(默认)银行卡
            }
          } else {
            message.error(
              formatMessage({
                id: 'Wrong payment password',
              }),
            );
          }
        });
      } catch (error) {
        console.error('verify payment password error: ', error);
      }
    },
    500,
    { leading: true, trailing: false },
  );

  useEffect(() => {
    form.setFields([
      {
        name: 'payment_password',
        value: '',
      },
    ]);
  }, [pathname]);

  return (
    <div className="verify-layout">
      <BackButton handleClick={() => history.goBack()} />
      <Row style={isPc ? { marginTop: '40px' } : { marginTop: '24px' }}>
        <Col
          span={isPc ? 12 : 24}
          style={{ maxWidth: '538px', margin: '0 auto' }}
        >
          <HeaderTitle
            title={formatMessage({ id: 'Verify' })}
            subTitle={formatMessage({
              id: 'Enter payment password to verify your identity.',
            })}
          />
          <div>
            <Form
              config={{
                type: 'Login',
                elements: [
                  {
                    type: 'Password',
                    label: formatMessage({ id: 'Payment Password' }),
                    name: 'payment_password',
                    fullRow: true,
                    required: true,
                    rules: [
                      {
                        validator: (rule: any, value: string) => {
                          if (!!value && !payNumberReg.test(value?.trim())) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'Payment password must be number!',
                                }),
                              ),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ],
                  },
                ],
              }}
              onSubmit={(values) => handleVerifyPaymentPassword(values)}
              locales={{
                submitText: formatMessage({
                  id: 'Next',
                  defaultMessage: 'Next',
                }),
                validateMessages: {
                  required:
                    '${label} ' +
                    formatMessage({
                      id: 'is required',
                    }),
                },
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VerifyPaymentPasswordPage;
